import { Dialog, DialogBackdrop } from '@headlessui/react';
import React, { ReactElement } from 'react';
import { closeModal } from 'xstate/actors/ModalActor';
import LoginModal from './LoginModal';
import { useModal } from 'xstate/hooks/useModal';
import { ModalView } from 'xstate/machines/ModalMachine';
import ActionableModal from './ActionableModal';
import AppDownloadModal from './AppDownloadModal';
import BoxModal from './BoxModal';
import CollectionModal from './CollectionModal';
import BoxDetailsModal from './BoxDetailsModal';
import MoveMemoModal from './MoveMemoModal';
import ProModal from './ProModal';
import MemoFormModal from './MemoFormModal';
import CommentsModal from './CommentsModal';
import ProfilePhotoModal from './ProfilePhotoModal';
import ChangeMemoDateModal from './ChangeMemoDateModal';

const Modal = (): ReactElement => {
  const { isOpen, view } = useModal();

  // Form modals shouldn't dismiss on a stray backdrop click / Escape, or the
  // user could lose their input — they close via their own buttons.
  const isDismissable =
    view !== ModalView.Box &&
    view !== ModalView.Collection &&
    view !== ModalView.MemoForm;
  const handleClose = () => {
    if (isDismissable) closeModal();
  };

  const renderModal = () => {
    switch (view) {
      case ModalView.Login:
        return <LoginModal />;
      case ModalView.Actionable:
        return <ActionableModal />;
      case ModalView.AppDownload:
        return <AppDownloadModal />;
      case ModalView.Box:
        return <BoxModal />;
      case ModalView.Collection:
        return <CollectionModal />;
      case ModalView.BoxDetails:
        return <BoxDetailsModal />;
      case ModalView.MoveMemo:
        return <MoveMemoModal />;
      case ModalView.Pro:
        return <ProModal />;
      case ModalView.MemoForm:
        return <MemoFormModal />;
      case ModalView.Comments:
        return <CommentsModal />;
      case ModalView.ProfilePhoto:
        return <ProfilePhotoModal />;
      case ModalView.ChangeMemoDate:
        return <ChangeMemoDateModal />;
    }
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} className={styles.dialog}>
      <DialogBackdrop transition className={styles.backdrop} />
      {renderModal()}
    </Dialog>
  );
};

const styles = {
  dialog: 'relative z-50',
  backdrop:
    'fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200 data-enter:ease-out data-leave:ease-in',
};

export default Modal;
